module.exports = __webpack_public_path__ + "static/media/ils_gold_purchase_pending.a7f0fb8c.svg";